// extracted by mini-css-extract-plugin
export default {"default":"TextElement_default__qEV9V","infoText":"TextElement_infoText__2Cyn7"};